// Single source of truth for "does this account have any SuperQRs outside
// the trash". Drives BOTH the cabinet hero empty state and the /survey
// chooser's redirect into the constructor, so the two can never disagree.
export function surveysLoaded(data) {
  return data != null && data.surveys !== undefined;
}

export function hasVisibleSurveys(data) {
  if (!data || !Array.isArray(data.surveys)) return false;
  return data.surveys.some(s => s && !s.removed);
}

// Set by Login.js right before post-register auto-login; consumed by
// Profile.js to route the fresh registrant onward to the constructor
// instead of /cabinet after the forced profile step.
export const POST_REGISTER_KEY = 'superqr.postRegister';

// Welcome-tour display counter is capped per browser AND per user: keying by
// username stops one account's exhausted tour quota from silencing the tour
// for a different account on a shared machine.
export function welcomeTourKey(username) {
  return username
    ? 'superqr.welcomeTour.shownCount.' + username
    : 'superqr.welcomeTour.shownCount';
}
